var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"sal-components-fund-quote-disclosure"},[_c('sal-components-disclosure',{staticClass:"sal-components-disclosure__wrapper sal-component",attrs:{"mwc-id":"salDisclosure"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }